import React from "react";
import PropTypes from "prop-types";

import { P, Flex } from "orcs-design-system";
import ProfileHeader from "src/commonComponents/ProfileHeader";
import { sanitizeGradientForColorPicker } from "src/util/gradient";
import GroupTypeBadge from "src/components/GroupTypeBadge";

const mockImage =
  "https://images.unsplash.com/photo-1464802686167-b939a6910659?q=80&w=3500&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

const TeamHeaderEditor = ({ value, onChange, disabled }) => {
  return (
    <Flex flexDirection="column" gap="r" mt="r">
      <P>
        Here you can set the default team header background gradient (which
        shows when a cover image hasn&apos;t been selected).
        <br />
        <strong>
          <em>Use the color picker to change the gradient.</em>
        </strong>
      </P>
      <ProfileHeader
        badges={
          <GroupTypeBadge
            group={{ id: "1", type: "Agile Group" }}
            groupTypes={{}}
          />
        }
        disabled={disabled}
        isShareButtonVisible={false}
        isActionMenuVisible={false}
        bannerUrl={sanitizeGradientForColorPicker(value)}
        profileName="Preview: Agile Group name"
        breadcrumbsConfig={[
          { id: "SI006", label: "Preview: Agile Group name" },
        ]}
        statsConfig={[
          { id: "teams", icon: ["fas", "users"], label: "200 Teams" },
          { id: "people", icon: ["fas", "user"], label: "2000 People" },
          { id: "OKRs", icon: ["fas", "bullseye"], label: "3 OKRs" },
        ]}
        onBackgroundColorChange={onChange}
        useColorPickerMode={true}
        avatarConfig={{
          image: mockImage,
          imageAlt: "Avatar for Nebula UI",
          shape: "square",
        }}
        entityType="team"
        id="team-profile-header"
      />
    </Flex>
  );
};

TeamHeaderEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default TeamHeaderEditor;
